/**
 * PANEL GÖRÜNÜM TERCİHLERİ — tek kaynak: `settings` tablosundaki `advanced_*`
 * anahtarları.
 *
 * ⚠⚠ BU BİR YETKİ KAPISI DEĞİL. `hasArea`/`RequireArea` bir ekrana ERİŞİMİ
 * kontrol eder; buradaki tercih yalnız o ekranın MENÜDE/SAYFADA GÖRÜNÜP
 * görünmeyeceğini belirler. Veri ve API hiçbir şekilde etkilenmez — kapalıyken
 * bile `/assets`, `/accounting`teki envanter/yıl-sonu uçları ve muhasebeci
 * paketi indirme AYNEN çalışır; operatör URL'yi bilse doğrudan açabilir.
 *
 * ⚠ M11 DENETİMİ (2026-09-16): duran varlıklar, yıl sonu kapanışı, envanter
 * defteri ve muhasebeci paketi bijberoep bir gerçek kişi için YASAL OLARAK
 * ZORUNLU DEĞİL (WER/CDE yalnız üç günlük defter + yıllık temel envanter
 * ister). Mükellef bunları SİLMEK değil, günlük akıştan UZAKLAŞTIRMAK istedi
 * — "ilerde kullanabiliriz" dedi. Bu yüzden anahtar veriyi/servisi değil,
 * yalnız panel görünürlüğünü kapatıyor.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { useAuth } from './auth-context';
import { hasArea } from './permissions';
import type { SettingsResponse } from '../pages/settings-types';

/**
 * ⚠ `/settings` ucu `@AreaAuth('settings')` taşır. Bu izni olmayan bir
 * kullanıcı için sorgu HİÇ ATILMAZ (403'ü beklemek yerine) ve varsayılan
 * "gizli DEĞİL" kabul edilir — tek sonucu, ayarı değiştiremeyen bir
 * kullanıcının modülleri hâlâ (kendi alan izni varsa) görmesidir; işlevsel
 * hiçbir şeyi bozmaz.
 *
 * ⚠ SORGU ANAHTARI (`['settings']`) Dashboard/Settings sayfalarıyla AYNI:
 * React Query aynı anda monte olan bileşenler arasında isteği tekilleştirir
 * — Sidebar ile Defter sayfası aynı yanıtı paylaşır, ikinci bir ağ isteği
 * doğmaz.
 */
export function useAdvancedModulesHidden(): boolean {
  const { user } = useAuth();
  const canReadSettings = hasArea(user, 'settings');
  const settings = useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get<SettingsResponse>('/settings'),
    enabled: canReadSettings,
  });
  return settings.data?.values.advanced_modules_hidden === 'true';
}
